(() => {
  const initialized = new WeakSet();

  const initialize = (root = document) => {
    root.querySelectorAll('product-tab').forEach((tab) => {
      const trigger = tab.querySelector('.diarist-product-tab-trigger');
      const content = tab.querySelector('.product-tab__content');
      if (!trigger || !content || initialized.has(tab)) return;
      initialized.add(tab);

      const synchronize = () => {
        const expanded = tab.classList.contains('opened');
        trigger.setAttribute('aria-expanded', String(expanded));
        content.setAttribute('aria-hidden', String(!expanded));
        content.inert = !expanded;
      };

      synchronize();
      new MutationObserver(synchronize).observe(tab, {
        attributes: true,
        attributeFilter: ['class'],
      });
    });
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;
        if (node.matches('product-tab')) initialize(node.parentElement || document);
        else if (node.querySelector('product-tab')) initialize(node);
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
